// extracted by mini-css-extract-plugin
export default {"deliveryStatusContent":"G2357fc"};